import { getTranslate } from '@/legacy-src/utilities/i18n'

import { Text } from '@/src/domains/design-system/components/Text'

export const ClientBookingFreeIntroSessionBlocker = () => {
  const { t } = getTranslate()

  return (
    <div className="flex w-full items-center rounded-xl bg-sand-400 p-5">
      <Text element="p" variant="sm">
        {t('component.cart.slotErrors.freeIntroSessionAlreadyUsed')}
      </Text>
    </div>
  )
}
